import React from "react";
import Navbar from "../components/NavBar";
import Footer from "../components/Footer";
import YourAttendingList from "../components/YourAttendingList";
import useTitle from "../components/Title";

const YourEvents = () => {
  useTitle("- Attending");

  return (
    <div className="">
      <Navbar />
      <div className="App-header mt-4">
        <div className="container-md">

          <h1 className="mt-5 event-heading-start">Attending.</h1>
          <p className="event-sub-text mb-3"> Events you're planning on Attending.  </p>


          <YourAttendingList />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default YourEvents;
